<template>
  <ErrorPageLayout
    code="500"
    title="Something went wrong on our side"
    description="A server-side error interrupted your request. Our team has been notified — try again in a moment, or head back to safer ground."
    :hint="hintText"
    tone="crimson"
  >
    <template #art>
      <svg viewBox="0 0 200 140" width="180" height="126" fill="none" aria-hidden="true">
        <!-- halo -->
        <ellipse cx="100" cy="74" rx="64" ry="58" fill="url(#p500-halo)" opacity="0.55"/>

        <!-- server stack -->
        <g stroke="#991b1b" stroke-width="3" stroke-linejoin="round">
          <!-- top unit -->
          <rect x="48" y="34" width="104" height="26" rx="5" fill="#ffffff"/>
          <circle cx="60" cy="47" r="3" fill="#991b1b"/>
          <line x1="74" y1="47" x2="138" y2="47" stroke-width="2" opacity="0.4"/>
          <!-- middle unit (broken — slight skew/crack) -->
          <rect x="48" y="64" width="104" height="26" rx="5" fill="#fef2f2"/>
          <circle cx="60" cy="77" r="3" fill="#ef4444">
            <animate attributeName="opacity" values="1;0.3;1" dur="1.2s" repeatCount="indefinite"/>
          </circle>
          <line x1="74" y1="77" x2="138" y2="77" stroke-width="2" opacity="0.4"/>
          <!-- crack line across the middle unit -->
          <path d="M78 64 L84 78 L80 82 L88 90" stroke="#ef4444" stroke-width="2.5" fill="none" stroke-linecap="round"/>
          <!-- bottom unit -->
          <rect x="48" y="94" width="104" height="26" rx="5" fill="#ffffff"/>
          <circle cx="60" cy="107" r="3" fill="#991b1b"/>
          <line x1="74" y1="107" x2="138" y2="107" stroke-width="2" opacity="0.4"/>
        </g>

        <!-- warning bolt over the broken unit -->
        <g>
          <circle cx="146" cy="48" r="14" fill="#ef4444" opacity="0.18"/>
          <path d="M148 38 L142 50 L148 50 L144 60 L154 47 L148 47 Z"
                fill="#ef4444" stroke="#7f1d1d" stroke-width="1.5" stroke-linejoin="round"/>
        </g>

        <!-- spark dots -->
        <circle cx="36" cy="120" r="3" fill="#ef4444" opacity="0.7">
          <animate attributeName="cy" values="120;112;120" dur="3s" repeatCount="indefinite"/>
        </circle>
        <circle cx="172" cy="120" r="2.5" fill="#fb7185" opacity="0.7">
          <animate attributeName="cy" values="120;114;120" dur="3.6s" repeatCount="indefinite"/>
        </circle>

        <defs>
          <radialGradient id="p500-halo">
            <stop offset="0%" stop-color="#ef4444" stop-opacity="0.4"/>
            <stop offset="100%" stop-color="#ef4444" stop-opacity="0"/>
          </radialGradient>
        </defs>
      </svg>
    </template>
  </ErrorPageLayout>
</template>

<script>
import ErrorPageLayout from './ErrorPageLayout.vue'

export default {
  name: 'Page500',
  computed: {
    hintText() {
      // Surface a correlation id if the upstream request handed one
      // off via ?ref=… — makes support triage instant.
      const ref = this.$route && this.$route.query && this.$route.query.ref
      return ref ? `Reference: ${ref}` : ''
    },
  },
  components: { ErrorPageLayout },
}
</script>
